/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5dfb97be94a0a080dde5f9495e9d273b58dcde9a";
